import React from 'react'
import './style/breadcrumb.css'
import { useNavigate } from 'react-router-dom';


function Breadcrumb({ steps }) {
    const navigate = useNavigate();
    return (
        <div className='mt-16 md:mt-20 ' >
            <div className="goldsmith-shop-hero goldsmith-page-hero page-hero-small">

                <img width="1920" height="1080" src="https://ninetheme.com/themes/goldsmith/wp-content/uploads/2022/11/1920-1.png"
                    className="attachment-2048x2048 size-2048x2048 entered lazyloaded" alt="" decoding="async"
                    data-lazy-src="https://ninetheme.com/themes/goldsmith/wp-content/uploads/2022/11/1920-1.png" data-ll-status="loaded" onClick={()=>navigate("/")}/>

                <noscript>
                    <img loading="lazy" width="1920" height="1080" src="https://ninetheme.com/themes/goldsmith/wp-content/uploads/2022/11/1920-1.png"
                        className="attachment-2048x2048 size-2048x2048" alt="" decoding="async"  onClick={()=>navigate("/")}/>
                </noscript>
                <div className="goldsmith-page-hero-content container">
                    <nav aria-label="Breadcrumbs" className="breadcrumb-trail goldsmith-breadcrumbs">
                        <ul className="trail-items goldsmith-breadcrumb flex">
                            <li className='cursor-pointer breadcrumb-item' onClick={()=>navigate("/")}>Home</li>
                            <li className='dot-breadceumb'>Product</li>
                        </ul>
                    </nav>
                    <h2 className="nt-hero-title page-title cursor-pointer">Product</h2>
                </div>
            </div>
        </div>
    )
}

export default Breadcrumb
